import { ajaxSend } from 'api/api';

export type APIPersistedNotificationT = {
  notification_id: string; //"8d619813-a495-4dad-9d15-88b7382fea56",
  organization_id: string; //"e7a04fc4-bba8-48a8-a92e-013606a188a6",
  receiver_id: string; //"5dc6597e-194d-47da-b728-ae8a415a573b",
  channel: string; //"/events/org/e7a04fc4-bba8-48a8-a92e-013606a188a6/user/5dc6597e-194d-47da-b728-ae8a415a573b",
  payload: string; //"{\"type\":\"bulkaction:started\",\"params\":{\"organization_id\":\"e7a04fc4-bba8-48a8-a92e-013606a188a6\",\"bulk_id\":\"0d9e0459-2cd5-4d2d-a71d-78caf26c79ef\",\"subject\":\"Bulk action: Tag\",\"message\":\"2 conversations in progress\",\"notification_type\":\"BulkActionInProgress\",\"total_conversations\":2,\"action_type\":\"Tag\"},\"emitted_by\":null}",
  sender_id: string; //"0d9e0459-2cd5-4d2d-a71d-78caf26c79ef",
  is_read: boolean;
  created_at: string; //"2020-05-25T09:10:21.718Z",
  read_at?: string; //"2020-05-25T09:26:45.370Z"
};

type NotificationsGetResponsePayloadT = {
  notifications: Array<APIPersistedNotificationT>;
};

export function getAllNotifications(): Promise<NotificationsGetResponsePayloadT> {
  return ajaxSend({
    path: '/v1/notifications',
  });
}

export function getUnreadNotifications(): Promise<NotificationsGetResponsePayloadT> {
  return ajaxSend({
    path: '/v1/notifications',
    params: {
      unread: true,
    },
  });
}

export function getNotificationById(
  notificationId: string,
): Promise<NotificationsGetResponsePayloadT> {
  return ajaxSend({
    path: `/v1/notifications/${notificationId}`,
  });
}

export function markNotificationAsRead(
  notificationIds: string[],
): Promise<NotificationsGetResponsePayloadT> {
  return ajaxSend({
    path: '/v1/notifications/read',
    method: 'PUT',
    data: {
      notification_ids: notificationIds,
    },
  });
}
